import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { createBrowserHistory } from 'history'
import React, { FC, Suspense } from 'react'
import { Provider } from 'react-redux'
import { renderRoutes } from 'react-router-config'
import { Router } from 'react-router-dom'
import { SnackbarProvider } from 'notistack'
import store from './redux/store'
import { routes } from './routes'
import palette from './theme/palette'
import typography from './theme/typography'
import overrides from './theme/overrides'
import AuthGuard from './ui/Pages/AuthGuard/AuthGuard'
import Loader from './ui/Molecules/Loader/Loader'
import './App.css'
import Notifier from './ui/Molecules/Notifier/Notifier'

const theme = createMuiTheme({
    palette,
    typography,
    overrides,
})
const history = createBrowserHistory()

const App: FC = () => (
    <Suspense fallback={<Loader />}>
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <SnackbarProvider
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    autoHideDuration={3000}
                >
                    <Notifier />
                    <Router history={history}>
                        <AuthGuard>{renderRoutes(routes)}</AuthGuard>
                    </Router>
                </SnackbarProvider>
            </ThemeProvider>
        </Provider>
    </Suspense>
)

export default App
